import ChartWidgetEditor from './ChartWidgetEditor';

export default ChartWidgetEditor;
